import axios from "axios";
import { call, put, takeEvery } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../../api/apiClient";
import { projectMeasureData } from "../../../components/chart/utils";
import {
  fetchSensorAverageDataStart,
  fetchSensorAverageDataSuccess,
  fetchSensorAverageFailure,
} from "../../../store/features/customer/sensor/sensorAverageDataSlice";

const URL = buildApiUrl("/api/v1/instruments/field_average_measure/");

const fetchSensorAverageDataApi = async ({
  accessToken,
  fieldId,
  from,
  to,
  measure,
  scope,
  source,
}) => {
  try {
    // Station metadata may still expose air_temperature, while its average is requested as temperature.
    const apiMeasure = source === "weather" && measure === "air_temperature"
      ? "temperature"
      : measure;
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
      params: {
        id: fieldId,
        from: from,
        to: to,
        measure: apiMeasure,
        interpolated: true,
      },
    });
    if (response.data?.error) throw response.data;
    return scope ? projectMeasureData(response.data, measure, true, apiMeasure) : response.data;
  } catch (error) {
    throw error.response?.data || (error.error ? error : { message: error.message });
  }
};

export function* handleFetchSensorAverageDataSaga(action) {
  const { fieldId, measure, scope, requestId } = action.payload;
  const identity = scope ? { scope, requestId } : {};
  try {
    const data = yield call(fetchSensorAverageDataApi, action.payload);
    yield put(fetchSensorAverageDataSuccess({ fieldId, measure, data, ...identity }));
  } catch (error) {
    yield put(fetchSensorAverageFailure(scope
      ? { ...identity, fieldId, measure, error }
      : error));
  }
}

export default function* sensorAverageDataSaga() {
  yield takeEvery(
    fetchSensorAverageDataStart.type,
    handleFetchSensorAverageDataSaga
  );
}
